















































































































































import { Component, Vue, Watch } from 'vue-property-decorator';
import { fmoney } from '@/common/money';
import calculate from '@/common/util/calculate';
import dayjs from 'dayjs';
import 'dayjs/locale/zh-cn';
import { TbOrderPad,TbGoods } from '@/http';
dayjs.locale('zh-cn')
@Component({
    components: {
    },
})
export default class onlineOrder extends Vue {
    public $refs: {
    };
    fmoney = fmoney;
    calculate = calculate;
    /**查询项 */
    searchValue={
        key:"",
        deliveryType:null,
        isNotPickUpGoods:null,
        isPartPickUpGoods:null,
        isAllPickUpGoods:null,
        skip:0,
        count:20,
    }

    /**时间控件 */
    pickerShow = false;
    startDate="";
    endDate="";

    /**列表加载相关 */
    refreshing= false;
    loading = false;
    finished = false;
    list=[];
    total=0;
    totalNum=0;
    totalPrice=0;
    totalUnSelfPickupNum=0;
    currentPage=1
    totalStock=0;

    timeActive=null;

    userInfo:any={};

    defaultDate = [];

    /**提货方式 */
    showDelivery = false;
    deliveryValue = null;
    deliveryName = "提货方式";
    deliveryOptions = [
        {
            label:'提货方式',
            value:null,
        },
        {
            label:'自提',
            value:2,
        },
        {
            label:'快递',
            value:1,
        },
    ]
    deliveryStatusOptions = [
        {
            label:'未提货',
            value:1,
        },
        {
            label:'部分提货',
            value:2,
        },
        {
            label:'已提货',
            value:3,
        },
    ]

    @Watch('searchValue.key')
    goodsChange(){
        this.getList();
    }
    
    
    created() {
    }
    
    async mounted() {
       
        this.userInfo = JSON.parse(localStorage.getItem('padUserinfo'));
       
       
    }

    
    /**下拉刷新 */
    onRefresh(){
        // 清空列表数据
      this.finished = false;
       // 重新加载数据
      // 将 loading 设置为 true，表示处于加载状态
      this.loading = true;
      this.searchValue.skip=0;
      this.currentPage = 1;
      this.loadMore();
    }
    /**触底加载 */
    async loadMore(){
            if (this.refreshing) {
            this.list = [];
            this.refreshing = false;
            }
            

            let s = this.searchValue.count;
            let res = await TbOrderPad.GetOnlineOrderList(Object.assign({},this.searchValue,{
                shopId:this.userInfo.shopId,
                orderStatus:2
            }))
            this.list = this.searchValue.skip==0? res.items:this.list.concat(res.items);
            this.total  = res.totalCount;
            this.totalNum = res.totalNum;
            this.totalPrice = res.totalPrice;
            this.totalUnSelfPickupNum = res.totalUnSelfPickupNum;
            this.currentPage++;
            this.searchValue.skip = (this.currentPage - 1) * s;
            this.loading = false;
            if (this.list.length >= this.total) {
            this.finished = true;
            
            }
    }

    async getList(){
        // this.onRefresh();
         // 清空列表数据
      this.finished = false;
        this.list = [];
        this.searchValue.skip=0;
        this.searchValue.count=20;
        this.total = 0;
        this.currentPage = 1;

        let res = await TbOrderPad.GetOnlineOrderList(Object.assign({},this.searchValue,{
            shopId:this.userInfo.shopId,
            orderStatus:2
        }))
        this.list = res.items;
        this.total  = res.totalCount;
        this.totalNum = res.totalNum;
        this.totalPrice = res.totalPrice;
        this.totalUnSelfPickupNum = res.totalUnSelfPickupNum;

    }



    /**重置 */
    resetSearch(){
        this.searchValue={
            key:"",
            deliveryType:null,
            isNotPickUpGoods:null,
            isPartPickUpGoods:null,
            isAllPickUpGoods:null,
            skip:0,
            count:20,
        }
        this.deliveryName='提货方式';
        this.timeActive=null;
        this.startDate = "";
        this.endDate = "";
        this.getList();
    }
    viewDetail(id){
        localStorage.setItem('allotactive','3')
        this.$router.push(`/pad/cashier/onlineOrderDetail?id=${id}`);
    }
    async changeDelivery(item){
        this.searchValue.deliveryType = item.value;
        this.deliveryName = item.label;
        this.showDelivery = false;
        await this.getList();
    }
    async chooseStatus(type){
        switch (type) {
            case 1:
                if(this.searchValue.isNotPickUpGoods==null){
                    this.searchValue.isNotPickUpGoods=true;
                }else{
                    this.searchValue.isNotPickUpGoods=!this.searchValue.isNotPickUpGoods;
                }
                break;
            case 2:
                if(this.searchValue.isPartPickUpGoods==null){
                    this.searchValue.isPartPickUpGoods=true;
                }else{
                    this.searchValue.isPartPickUpGoods=!this.searchValue.isPartPickUpGoods;
                }
                break;
            case 3:
                if(this.searchValue.isAllPickUpGoods==null){
                    this.searchValue.isAllPickUpGoods=true;
                }else{
                    this.searchValue.isAllPickUpGoods=!this.searchValue.isAllPickUpGoods;
                }
                break;
        
            default:
                break;
        }
        await this.getList();
    }
    getDeliveryType(val){
        let str = "";
        str = this.deliveryOptions.some(v=>v.value==val)?this.deliveryOptions.find(v=>v.value==val).label:'';
        return str;
    }
    getDeliveryState(val){
        let str = "";
        str = this.deliveryStatusOptions.some(v=>v.value==val)?this.deliveryStatusOptions.find(v=>v.value==val).label:'';
        return str;
    }
   
}



// WEBPACK FOOTER //
// ./node_modules/_vue-loader@14.2.4@vue-loader/lib/selector.js?type=script&index=0!./src/views/padViews/cashier/components/onlineOrder.vue